import { t } from '@lingui/macro';
import * as Yup from 'yup';

export const validationSchema = (orderAmount: number, orderRemainingAmount: number, hasDraftPartialInvoices) =>
    Yup.object().shape({
        productId: Yup.string().required(),
        isFixedAmount: Yup.bool().required(),
        amount: Yup.number()
            .required()
            .moreThan(0)
            .when('isFixedAmount', {
                is: true,
                then: Yup.number().max(orderRemainingAmount, t`The entered amount exceeds the remaining order total.`),
                otherwise: Yup.number().max(
                    (orderRemainingAmount * 100.0) / orderAmount,
                    t`The entered amount exceeds the remaining order total.`
                ),
            }),
        canInvoiceFullRemainingAmount: Yup.boolean().test(
            'is-invoicing-all-remaining.-amount',
            t`Please book pending partial invoices before invoicing the remaining amount on the order`,
            function () {
                if (hasDraftPartialInvoices) {
                    if (this.parent.isFixedAmount) {
                        return this.parent.amount !== orderRemainingAmount;
                    }
                    const calculatedFixedAmount = (orderAmount * this.parent.amount) / 100.0;
                    return calculatedFixedAmount !== orderRemainingAmount;
                }
                return true;
            }
        ),
    });
